<ng-template #myNetwork let-modal>
  <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: Merchant?.webapp_settings?.menu_color,
            'border-bottom':
          Merchant?.webapp_settings?.menu_border_width +
          'px solid ' +
          Merchant?.webapp_settings?.menu_border_color,
      }"
    >
      <a (click)="modal.close()" id="btnnotification" class="close-icon">
        <i [ngStyle]="{ color: Merchant?.webapp_settings?.menu_font_color_homepgae }" class="zmdi zmdi-close zmdi-hc-fw"></i>
      </a>
    </div>
    <div class="modal-body">
      @if (onlineStatus === "offline") {
        <div>
          <p
            [ngStyle]="
              Merchant.multi_outlet
                ? { color: Merchant.menu_font_color_allpage }
                : { color: Merchant.webapp_settings?.menu_font_color_allpage }
            "
          >
            {{ onlineStatusMessage }}
          </p>
        </div>
      }
    </div>
    <div class="modal-footer row row-cols-2 justify-content-center">
      <button type="button" class="btn" [ngStyle]="
                Merchant.multi_outlet
                  ? {
                      color: Merchant.menu_font_color_homepgae,
                      backgroundColor: Merchant.menu_color,
                      border:
                        Merchant.menu_border_width +
                        'px solid ' +
                        Merchant.menu_border_color,
                    }
                  : {
                      color: Merchant.webapp_settings?.menu_font_color_homepgae,
                      backgroundColor: Merchant.webapp_settings?.menu_color,
                      border:
                        Merchant.webapp_settings?.menu_border_width +
                        'px solid ' +
                        Merchant.webapp_settings?.menu_border_color,
                    }
        "
        (click)="reconnect()"
      >
        Reconnect
      </button>
    </div>
  </div>
</ng-template>
